@if (md$ | async; as md) {
  <markdown class="markdown">{{ md }}</markdown>
}
<div class="footer-spacing"></div>
